import { useEffect, useRef } from 'react';
import type { DependencyList } from 'react';
import deepEqual from 'react-fast-compare';

/*
  useEffectDeep: Similar to useEffect, but compares dependencies deeply before
  executing callback.
*/

export function useDeepEffect(
  callback: () => (() => void) | void,
  dependencies: DependencyList,
) {
  // State and setters for debounced value
  const ref = useRef<DependencyList>(null);

  if (!deepEqual(dependencies, ref.current)) {
    ref.current = dependencies;
  }

  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(callback, ref.current ?? undefined);
}
